<template>
  <div class="main">
    <el-row>
      <!-- 查询条件 -->
      <el-col class="pagin" ref="query">
        <el-row class="mb5 mt2 ml2">
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">用户编号 :</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.userId" size="small" placeholder="用户编号" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">角色 :</div>
            <div class="pl4-6 width-200">
              <el-select v-model="formQuery.roleId" filterable placeholder="请选择角色" clearable size="small" class="full" @clear="onSelectClear('roleIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'roleId', 'roleIdCacheList')">
                  <el-option v-for="(item, index) in roleIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">真实姓名 :</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.realname" size="small" placeholder="真实姓名" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">状态 :</div>
            <div class="pl4-6 width-200">
              <el-select clearable v-model="formQuery.status" placeholder="请选择状态" size="small">
                <el-option v-for="(item, index) in dictStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">创建时间 :</div>
            <div class="pl4-6 width-200">
              <el-date-picker
                style="width: 205px;"
                :clearable="true"
                v-model="createTimeDate"
                :picker-options="disabledAfterNow"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div class="inline-block mr4">
            <el-button v-if="checkPermission(funcData, 'query')" size="small" type="primary" icon="el-icon-search" @click="onQuery">查找</el-button>
            <el-button v-if="checkPermission(funcData, 'add')" size="small" type="primary" icon="el-icon-plus" @click="onShowAdd">添加</el-button>
          </div>
          <!-- 批量操作按扭 -->
          <el-dropdown v-if="checkPermission(funcData, 'batchEnable,batchDisable')" size="small" type="primary" trigger="click">
            <el-button type="primary" size="small">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="checkPermission(funcData, 'batchEnable')" class="px10" @click.native="onBatchEnable">批量启用</el-dropdown-item>
              <el-dropdown-item v-if="checkPermission(funcData, 'batchDisable')" class="px10" @click.native="onBatchDisable">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link type="primary" @click="showMore=!showMore" style="margin-left:10px;">{{showMore?'收起∧':'展开∨'}}</el-link>
        </el-row>
      </el-col>
      <el-col v-if="!checkPermission(funcData, 'query')" :style="{height: pageHeight,lineHeight: pageHeight}" class="noPer">没有列表查询权限</el-col>

      <!-- 表格  -->
      <el-col v-else>
        <el-table
          ref="table"
          v-loading="pageLoading"
          element-loading-text="拼命加载中"
          size="mini"
          stripe
          border
          style="width: 100%"
          :height="pageHeight"
          :data="dataList"
          :header-cell-class-name="onHeaderClass"
          @sort-change="onSortChange"
          @selection-change="onSelectionChange"
          ><!-- :default-sort = "{prop: 'date', order: 'descending'}" -->

          <el-table-column
            v-if="checkPermission(funcData, 'batchEnable,batchDisable')"
            type="selection"
            width="45"></el-table-column>

          <el-table-column align="center" label="序号" type="index"></el-table-column>

          <el-table-column width="185px" align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(funcData, 'detail')" size="mini" @click="onDetail(scope.$index, scope.row)">查看</el-button>
              <el-button
                v-if="checkPermission(funcData, 'modify')"
                size="mini"
                type="info"
                @click="onShowEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                v-if="checkPermission(funcData, 'modify')"
                size="mini"
                type="warning"
                @click="onShowPwd(scope.$index, scope.row)">重置密码</el-button>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="userId"
            label="用户编号"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="roleId"
            label="角色"
            sortable="custom"
            >
            <template slot-scope="scope">
              {{scope.row.roleId|dict(roleIdCacheListCopy)}}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="realname"
            label="真实姓名"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="status"
            label="状态"
            sortable="custom"
            >
            <template slot-scope="scope">
              <el-switch
                v-if="checkPermission(funcData, 'enable,disable')"
                :disabled="((scope.row.status!='1' && !checkPermission(funcData, 'enable')) || (scope.row.status=='1' && !checkPermission(funcData, 'disable')))"
                style="margin-right: 5px;"
                @change="onSwitch(scope.$index, scope.row)"
                v-model="scope.row.switch"
                active-color="#409eff"
                inactive-color="#dcdfe6">
              </el-switch>
              <el-tag size="small" type="success" v-if="scope.row.status == '1'">{{scope.row.status|dict(dictStatus)}}</el-tag>
              <el-tag size="small" type="danger" v-else>{{scope.row.status|dict(dictStatus)}}</el-tag>
            </template>

          </el-table-column>
        </el-table>
      </el-col>

      <!-- 分页 -->
      <el-col class="pagination">
        <el-pagination
          background
          :current-page="pageParam.pageNo"
          :page-sizes="[30, 50, 100, 200, 500, 1000]"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          layout="prev, pager, next, total, jumper, sizes"
          :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 详情弹窗 -->
    <el-dialog :close-on-click-modal="false" title="用户详情" :visible.sync="dialogDetail" width="600px" top="8vh">
      <el-row type="flex">
        <el-col :span="8" class="userDetailTitle paramDetail bd1 mt1">用户编号</el-col>
        <el-col :span="16" class="paramDetail bd1 ml1 mt1">{{dataDetail.userId}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8" class="userDetailTitle paramDetail bd1 mt1">角色</el-col>
        <el-col :span="16" class="paramDetail bd1 ml1 mt1">{{dataDetail.roleId|dict(roleIdCacheListCopy)}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8" class="userDetailTitle paramDetail bd1 mt1">用户账户</el-col>
        <el-col :span="16" class="paramDetail bd1 ml1 mt1">{{dataDetail.username}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8" class="userDetailTitle paramDetail bd1 mt1">真实姓名</el-col>
        <el-col :span="16" class="paramDetail bd1 ml1 mt1">{{dataDetail.realname}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8" class="userDetailTitle paramDetail bd1 mt1">状态</el-col>
        <el-col :span="16" class="paramDetail bd1 ml1 mt1">{{dataDetail.status|dict(dictStatus)}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8" class="userDetailTitle paramDetail bd1 mt1">最后操作员</el-col>
        <el-col :span="16" class="paramDetail bd1 ml1 mt1">{{dataDetail.operatorId}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8" class="userDetailTitle paramDetail bd1 mt1">创建时间</el-col>
        <el-col :span="16" class="paramDetail bd1 ml1 mt1">{{dataDetail.createTime}}</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加弹窗 -->
    <el-dialog :close-on-click-modal="false" title="添加用户" :visible.sync="dialogAdd" width="550px" @closed="onResetForm('formAdd')" top="8vh">
      <el-form :model="formAdd" ref="formAdd" :rules="formAddRules" size="mini">
        <el-form-item label="角色" prop="roleId" :label-width="formLabelWithAdd">
          <el-select v-model="formAdd.roleId" filterable placeholder="请选择角色" clearable size="small" class="full width-200" @clear="onSelectClear('roleIdCacheList')" :filter-method="val=>onSelectFilter(val, formAdd, 'roleId', 'roleIdCacheList')">
            <el-option v-for="(item, index) in roleIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户账户" prop="username" :label-width="formLabelWithAdd">
          <el-input class="width-200" v-model="formAdd.username" placeholder="请输入用户账户" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="userpwd" :label-width="formLabelWithAdd">
          <el-input class="width-200" v-model="formAdd.userpwd" placeholder="请输入用户密码" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realname" :label-width="formLabelWithAdd">
          <el-input class="width-200" v-model="formAdd.realname" placeholder="请输入真实姓名" maxlength="60"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitAdd()" size="small">提 交</el-button>
        <el-button @click="dialogAdd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 修改弹窗 -->
    <el-dialog :close-on-click-modal="false" title="修改用户" :visible.sync="dialogModify" width="550px" @closed="onResetForm('formEdit')" top="8vh">
      <el-form :model="formEdit" ref="formEdit" :rules="formEditRules" size="mini">
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="formEdit.roleId" filterable placeholder="请选择角色" clearable size="small" class="full width-200" @clear="onSelectClear('roleIdCacheList')" :filter-method="val=>onSelectFilter(val, formEdit, 'roleId', 'roleIdCacheList')">
            <el-option v-for="(item, index) in roleIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户账户" prop="username">
          <el-input class="width-200" v-model="formEdit.username" placeholder="请输入用户账户" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realname">
          <el-input class="width-200" v-model="formEdit.realname" placeholder="请输入真实姓名" maxlength="60"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitEdit()" size="small">提 交</el-button>
        <el-button @click="onResetEdit" size="small">重 置</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码弹窗 -->
    <el-dialog :close-on-click-modal="false" title="重置密码" :visible.sync="dialogResetPwd" width="600px" @closed="onResetForm('resetPwdForm');">
      <el-form :model="resetPwdForm" ref="resetPwdForm" :rules="resetPwdFormRules" size="mini">
        <el-form-item label="登录密码" prop="loginPwd">
          <el-input type="password" class="width-200" v-model="resetPwdForm.loginPwd" placeholder="请输入当前登录用户的密码" maxlength="32"></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="userPwd">
          <el-input class="width-200" v-model="resetPwdForm.userPwd" placeholder="请输入新密码" maxlength="32"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type='primary' @click="onSubmitPwd()" size="small">提 交</el-button>
        <el-button @click="dialogResetPwd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import validator from '@/utils/validator' // 引入检查器
import rsa from '@/utils/rsa'
import axios from 'axios'

export default {
  name: 'merplatAuthUser',
  data () {
    return {
      menuName: 'merplatAuthUser',
      dialogResetPwd: false, // 修改密码对话框
      // 表单对象
      formQuery: { // 查询对象
        userId: '', // 用户编号
        roleId: '', // 角色
        realname: '', // 真实姓名
        status: '', // 状态
        createTimeBegin: '', // 创建时间-开始时间
        createTimeEnd: '' // 创建时间-结束时间
      },
      formAdd: { // 新增对象
        roleId: '', // 角色
        username: '', // 用户账户
        userpwd: '', // 用户密码
        realname: '' // 真实姓名
      },
      resetPwdForm: { // 重置密码
        loginPwd: '',
        userId: '',
        userPwd: ''
      },
      resetPwdFormRules: {
        loginPwd: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
        userPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      },
      // 表单字段规则
      formAddRules: { // 新增规则
        roleId: [{ required: true, message: '请输入角色', trigger: 'blur' }],
        username: [{ required: true, message: '请输入用户账户', trigger: 'blur' }, { validator: validator.letterDigital, trigger: 'blur' }],
        userpwd: [{ required: true, message: '请输入用户密码', trigger: 'blur' }, { validator: validator.letterDigitalSymbol, trigger: 'blur' }],
        realname: [{ validator: validator.chinese, trigger: 'blur' }]
      },
      formEditRules: { // 更新规则
        roleId: [{ required: true, message: '请输入角色', trigger: 'blur' }],
        username: [{ required: true, message: '请输入用户账户', trigger: 'blur' }, { validator: validator.letterDigital, trigger: 'blur' }],
        realname: [{ validator: validator.chinese, trigger: 'blur' }]
      },
      // 定义字典对象
      dictStatus: [], // 状态
      roleIdCacheList: [],
      roleIdCacheListCopy: [],
      disabledAfterNow: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      idName: 'userId',
      httpUrl: '/auth/user',
      httpUri: {
        roleIdCacheUri: '/select/role',
        other: ''
      }
    }
  },
  mounted () {
    this.getSysDict('STATUS_TYPE', 'dictStatus', 'getStatus')
    this.httpSelectList('roleIdCacheList', this.httpUri.roleIdCacheUri)
  },
  methods: {
    onShowPwd (index, row) {
      this.resetPwdForm.userId = row.userId
      this.dialogResetPwd = true
    },
    onSubmitPwd () {
      this.$refs.resetPwdForm.validate((valid) => {
        if (valid) {
          axios({
            url: this.pageUrl + '/resetPwd',
            method: 'post',
            data: {
              userId: this.resetPwdForm.userId,
              loginPwd: rsa.rsaPublicData(this.resetPwdForm.loginPwd),
              userPwd: rsa.rsaPublicData(this.resetPwdForm.userPwd)
            }
          }).then(res => {
            if (res.data.code === '0000') {
              this.dialogResetPwd = false
              this.$message.success(res.data.message)
            }
          }).catch(err => console.log(err, 'onSubmitPwd'))
        } else {
          // console.log('error http!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.main {
  margin: 10px;
  background-color: #fff;
}
.paramDetail {
  min-height: 43px;
  padding: 0 10px;
  line-height: 40px;
}
.el-button+.el-button {
  margin-left: 4px;
}
.el-button--mini, .el-button--mini.is-round {
  padding: 5px 7px;
}
div.mt2 {
  margin-top: 0;
}
div.el-row.mt2.mb5 > div.mr10 {
  margin-top: 10px;
}
</style>
